export default __webpack_public_path__ + "static/media/delete-btn.0359b2eb.svg";